import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PaginationSection from "../../../components/Product/Pagination";
import MyCount from "../../../components/MyPage/MyCount";
import { MY_PAGE_DEPOSIT_LIST_URL, MY_PAGE_POINT_LIST_URL } from "../../../utils/urls";
import instance from "../../../services/services";
import { formatLocalString } from "../../../utils/validation";
import { useLanguage } from "../../../hooks/useLanguage";

function DepositAndPointList({ type }) {
  const { t } = useLanguage();
  const [isTablet, setIsTablet] = useState(false);
  const [state, setState] = useState({ activeTab: '' });
  const [depositList, setDepositList] = useState([]);
  const [pointList, setPointList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const itemsPerPage = 12;
  const [activeType, setActiveType] = useState("");
  const [totalBalance, setTotalBalance] = useState(0);
  const [totalPoint, setTotalPoint] = useState(0);
  const [depositData, setDepositData] = useState({});

  // 모바일 체크
  useEffect(() => {
    const checkTablet = () => {
      setIsTablet(window.innerWidth < 768);
    };

    checkTablet();
    window.addEventListener('resize', checkTablet);

    return () => window.removeEventListener('resize', checkTablet);
  }, []);

  const filterList = {
    deposit: [
      { name: t("all"), value: '' },
      { name: t("deposit_info_9"), value: 'charge' },
      { name: t("use"), value: 'order' },
      { name: t("deposit_info_10"), value: 'refund' },
    ],
    point: [
      { name: t("all"), value: '' },
      { name: t('save'), value: 'plus' },
      { name: t('use'), value: 'minus' },
      { name: t('expire'), value: 'expire' },
    ]
  };

  // 페이지 변경 핸들러
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // 화살표 클릭 핸들러
  const handleArrowClick = (page) => {
    handlePageChange(page);
  };

  // 탭 클릭 핸들러
  const handleActiveTab = (filter) => {
    setState(prev => ({
      ...prev,
      activeTab: filter.value
    }));
    setActiveType(filter.value);
    setCurrentPage(1);
  };

  // 예치금 리스트 API 호출
  useEffect(() => {
    const fetchDepositList = async () => {
      try {
        const response = await instance.post(MY_PAGE_DEPOSIT_LIST_URL, {
          type: activeType,
          offset: currentPage,
          limit: itemsPerPage
        });
        setDepositList(response.data.data.data);
        setTotalBalance(response.data.data.total_balance);
        setTotalCount(response.data.data.total_count);
        setDepositData(response.data.data);
      } catch (error) {
        console.error('예치금 리스트 가져오기 실패:', error);
      }
    };
    
    if (type === 'deposit') {
      fetchDepositList();
    }
  }, [type, activeType, currentPage]);

  // 포인트 리스트 API 호출
  useEffect(() => {
    const fetchPointList = async () => {
      try {
        const response = await instance.post(MY_PAGE_POINT_LIST_URL, {
          type: activeType, // 포인트 API 호출 시에도 activeType 사용
          offset: currentPage,
          // limit: itemsPerPage
        });
        setPointList(response.data.data.data);
        setTotalCount(response.data.data.total_count);
        setTotalPoint(response.data.data.totalPoint);
      } catch (error) {
        console.error('포인트 리스트 가져오기 실패:', error);
      }
    };
    
    if (type === 'point') {
      fetchPointList();
    }
  }, [type, activeType, currentPage]); // activeType 의존성 추가

  return (
    <div>
      {/* 예치금, 포인트리스트 진입페이지 */}
      <div>
        {/* 장바구니 / 관심상품 / 쿠폰 */}
        {!isTablet && <MyCount />}

        {/* 예치금 */}
        {type === 'deposit' ? (
          <div>
            <div className="my_container deposit_container mt_24">
              <div className="alert_box gray deposit_info_box">
                <p className="deposit_price">
                  {t("total_deposit")}
                  <span className="price">{formatLocalString(totalBalance || 0)}</span>
                  {t("won_0617")}
                </p>
                <div className="deposit_info_list">
                  <p className="deposit_price">
                    {t("refund_possible")}
                    <span className="price_refund">{formatLocalString(depositData?.refundable_balance || 0)}</span>
                    {t("won_0617")}
                  </p>
                  <p className="deposit_price">
                    {t("refund_impossible")}
                    <span className="price_refund">{formatLocalString(depositData?.non_refundable_balance || 0)}</span>
                    {t("won_0617")}
                  </p>
                </div>
                <div className="btn_group_4 w-100 flex-justify-center">
                  <Link className="default_btn sm black" to="/myPage/deposit/charge">{t("charge")}</Link>
                  <Link className="default_btn sm white" to="/myPage/deposit/refund">{t("refund")}</Link>
                </div>
              </div>
            </div>

            <div className="my_container mt_48">
              <div className="order_title">
                <h3>{t("deposit_info_11")}</h3>
                <ul className="text_filter">
                  {filterList.deposit.map(filter => (
                    <li
                      className={`group_item ${state.activeTab === filter.value ? 'active' : ''}`}
                      style={{ cursor: 'pointer' }}
                      key={filter.value}
                      onClick={() => handleActiveTab(filter)}
                    >
                      <span>{filter.name}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="board_container form_board">
                {/* <ul className="point_list">
                  {depositList.map((item, index) => (
                    <li className="board_item" key={index}>
                      <div className="board_box flex-4 column">
                        <h6 className="title flex-center-4">
                          <span>{item.type_label}</span>
                          {item.status && <div className="badge sm g-100">{item.status}</div>}
                        </h6>
                        <div className="board_info board_line">
                          <span className="text_small_b g-70">{item.balance_comment}</span>
                        </div>
                      </div>
                      <div className="board_status point_value">
                        {item.status === "대기중" ? (
                          <span className="strong_b1 point gray">
                            {item.gb === 'plus' ? '+' : '-'}{formatLocalString(item.balance)}원
                          </span>
                        ) : (
                          <span className={`strong_b1 point ${item.type_label === "충전" ? 'black' : 'red'}`}>
                            {item.type_label === "충전" ? '+' : '-'}{formatLocalString(item.balance)}원
                          </span>
                        )}
                      </div>
                    </li>
                  ))}
                </ul> */}

                <ul className="point_list">
                  {depositList.map((item, index) => (
                    <li className="board_item" key={index}>
                      <div className="board_box flex-4 column">
                        <h6 className="title flex-center-4">
                          <span>{item.type_label}</span>
                          {item.complete_flag === 'N' && <div className="badge sm g-100">{item.status}</div>}
                        </h6>
                        <div className="board_info board_line">
                          {item.type === "order" ? (
                            <>
                              <Link className="text_small_b g-70 text_underline" to={`/myPage/order?type=${item.order_kind}&orderNumber=${item.ordno}`}>{item.ordno}</Link>
                              <span className="text_small_b" style={{color: '#ddd'}}></span>
                              <span className="text_small_b g-70">{item.regist_date}</span>
                            </>
                          ) : (
                            <span className="text_small_b g-70">{item.balance_comment}</span>
                          )}
                        </div>
                      </div>
                      <div className="board_status point_value">
                        {item.complete_flag === 'N' ? (
                          <span className="strong_b1 point gray">
                            {item.gb === 'plus' ? '+' : '-'}{formatLocalString(item.balance)}원
                          </span>
                        ) : (
                          <span className={`strong_b1 point ${
                            item.type === "order" ? 
                              (item.gb === "plus" ? "black" : "red") : 
                              (item.balance_type === 'charge' ? 'black' : 'red')
                          }`}>
                            {item.type === "order" ? 
                              (item.gb === "plus" ? "+" : "-") : 
                              (item.balance_type === 'charge' ? '+' : '-')
                            }{formatLocalString(item.balance)}원
                          </span>
                        )}  
                      </div>
                    </li>
                  ))}
                </ul>



                {depositList.length === 0 && (
                  <div className="default_info_table no_data text_center pt_48">
                    {t("deposit_list")}
                  </div>
                )}

                {totalCount > 0 && (
                  <PaginationSection
                    totalCount={totalCount}
                    itemsPerPage={itemsPerPage}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                    onArrow={handleArrowClick}
                  />
                )}
              </div>
            </div>
          </div>
        ) : (
          // 포인트
          <div>
            <div className="my_container point_container mt_48">
              <div className="order_title">
                <div className="flex-center-4">
                  <h3>{t("point")}</h3>
                  <span className="p2 red">{formatLocalString(totalPoint || 0)}P</span>
                </div>
                <ul className="text_filter">
                  {filterList.point.map(filter => (
                    <li
                      className={`group_item ${state.activeTab === filter.value ? 'active' : ''}`}
                      style={{ cursor: 'pointer' }}
                      key={filter.value}
                      onClick={() => handleActiveTab(filter)}
                    >
                      <span>{filter.name}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="board_container form_board">
                <ul className="point_list">
                  {pointList.map((item, index) => (
                    <li className="board_item" key={index}>
                      <div className="board_box flex-4 column">
                        <h6 className="title flex-center-4">
                          <span>{item?.type_name}</span>
                        </h6>
                        <div className="board_info board_line">
                          {item?.order_kind ? (
                            // order_kind가 있으면 클릭 가능한 링크
                            <span 
                              className="text_small_b g-70" 
                              style={{ 
                                textDecoration: 'underline', 
                                cursor: 'pointer' 
                              }}
                              onClick={() => {
                                const type = item.order_kind;
                                const orderNumber = item.order_no;
                                window.open(`/myPage/order?type=${type}&orderNumber=${orderNumber}`, '_blank');
                              }}
                            >
                              {item?.order_no || '데이터 없음'}
                            </span>
                          ) : (
                            // order_kind가 없으면 일반 텍스트
                            <span className="text_small_b g-70">
                              {item?.order_no || '데이터 없음'}
                            </span>
                          )}
                          <span className="text_small_b g-70">
                            {item?.gb === 'minus' && activeType === 'expire' 
                              ? (item?.limit_date || '만료일 없음') 
                              : item?.gb === 'minus' && activeType !== 'expire'
                              ? (item?.use_date || '만료일 없음')
                              : (item?.limit_date || '만료일 없음')
                            } 
                            {!(item?.gb === 'plus' && item?.limit_date === null) && 
                              (item?.gb === 'plus' ? ' 소멸예정' : item?.gb === 'minus' ? ' 사용' : ' 소멸')
                            }
                          </span>
                        </div>
                      </div>  
                      <div className="board_status point_value">
                        <span className={`strong_b1 point ${item?.gb === 'minus' ? 'red' : item?.gb === 'expire' ? 'gray' : ''}`}>
                          {item?.gb === 'plus' ? '+' : item?.gb === 'minus' ? '-' : ''}{formatLocalString(item?.point || 1000)}P
                        </span>
                      </div>
                    </li>
                  ))}
                </ul>

                {pointList.length === 0 && (
                  <div className="default_info_table no_data text_center pt_48">
                    {t("point_list")}
                  </div>
                )}


                {totalCount > 0 && (
                  <PaginationSection
                    totalCount={totalCount}
                    itemsPerPage={itemsPerPage}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                    onArrow={handleArrowClick}
                  />
                )}
              </div>
            </div>

            {/* 포인트 안내 */}
            <div className="alert_box gray mt_48">
              <h6 className="strong_b1">{t("point_info")}</h6>
              <p className="px-4 dash_list flex-2 column">
                <span className="guide_text_1 g-80">
                  {t("point_info_2")}
                </span>
                <span className="guide_text_1 g-80">
                  {t('point_info_3')}<br />
                  ({t('point_info_4')})
                </span>
                <span className="guide_text_1 g-80">
                  {t("point_info_5")}
                </span>
                <span className="guide_text_1 g-80">
                  {t('point_info_6')} {t('point_info_7')}
                </span>
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default DepositAndPointList;